import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { createDateAdapter } from '../../utils/dateFormatter';

// Create a custom date adapter that formats dates as dd/mm/yyyy
const CustomDateAdapter = createDateAdapter(AdapterDateFns);

/**
 * Global date provider component that ensures consistent date formatting
 * across the entire application using dd/mm/yyyy format
 */
const DateProvider = ({ children }) => {
  return (
    <LocalizationProvider dateAdapter={CustomDateAdapter}>
      {children}
    </LocalizationProvider>
  );
};

export default DateProvider;
